import React, { Component } from "react";

import AuthStore from "./components/login/store/authstore";
import CommonStore from "./common/commonstore";
import { Provider } from "mobx-react";
import ReferenceDataStore from "./components/referencedata/store/reference-data-store";
import NGLTeamDailyReportStore from "./components/nglteamdailyreport/store/ngl-team-daily-report-store";
import NGLTowerConstraintsStore from "./components/ngltowerconstraints/store/ngl-tower-constraints-store";
import OutageScheduleReportStore from "./components/OutageScheduleReport/store/outage-schedule-report-store";
import Routes from "./Routes";
import SessionStorageSession from "./common/services/session-storage-service";
import OutageScheduleUserStore from "./components/OutageScheduleReport/store/outage-schedule-user-store";
import MarketingRepUserStore from "./components/soxauditscreen/store/marketing-rep-user-store";
import LeaseMasterPriceChangeStore from "./components/soxauditscreen/store/lease-master-price-change-store";
import VendortTemplateDataStore from "./components/generatorvendortemplatescreen/store/generator-vendor-template-store";
import GainlossTransactionScreenStore from "./components/gainlossscreen/store/gainloss-transaction-screen-store";
import GainLossReferenceDataStore from "./components/gainlossscreen/store/gain-loss-reference-screen--store";
import GainLossListsScreenStore from "./components/gainlossscreen/store/gainloss-lists-screen-store";
import GainLossUnitPriceDataStore from "./components/gainlossscreen/store/gainloss-unitprice-screen-store";
import GainLossSystemVarianceDataStore from "./components/gainlossscreen/store/gainloss-system-variance-screen-store";
import GainLossSubSystemVarianceDataStore from "./components/gainlossscreen/store/gain-loss-subSystemVariance-screen--store";
import ReleaseIncidentDataStore from "./components/releaseincident/store/release-incident-store";
import SystemPipeLineListsScreenStore from "./components/systempipeline/store/systempipeline-lists-screen-store";
import SystemListsScreenStore from "./components/systempipeline/store/system-lists-screen-store";
import NominationScreenStore from "./components/nomination/store/nomination-data-store";
import PLMAlarmDataStore from "./components/plm-alarm/store/plm-alarm-data-store"
import NGLSpotPriceAndTowerTargetsDataStore from "./components/ngl-spot-price-and-tower-targets/store/spot-price-and-tower-targets-screen-store";

const authTokenOnPageLoad = SessionStorageSession.getSessionStorageAuth();
if (authTokenOnPageLoad) {
    AuthStore.setAuthInfo(authTokenOnPageLoad, true);
}

class MainSolution extends Component {
    render() {
        return (
            <Provider
                AuthStore={AuthStore}
                CommonStore={CommonStore}
                ReferenceDataStore={ReferenceDataStore}
                NGLTeamDailyReportStore={NGLTeamDailyReportStore}
                NGLTowerConstraintsStore={NGLTowerConstraintsStore}
                OutageScheduleReportStore={OutageScheduleReportStore}
                VendortTemplateDataStore={VendortTemplateDataStore}
                OutageScheduleUserStore={OutageScheduleUserStore}
                MarketingRepUserStore={MarketingRepUserStore}
                LeaseMasterPriceChangeStore={LeaseMasterPriceChangeStore}
                GainLossTransactionScreenStore={GainlossTransactionScreenStore}
                GainLossListsScreenStore={GainLossListsScreenStore}
                GainLossReferenceDataStore={GainLossReferenceDataStore}
                GainLossUnitPriceDataStore={GainLossUnitPriceDataStore}
                GainLossSystemVarianceDataStore={GainLossSystemVarianceDataStore}
                GainLossSubSystemVarianceDataStore={GainLossSubSystemVarianceDataStore}
                ReleaseIncidentDataStore={ReleaseIncidentDataStore}
                SystemPipeLineListsScreenStore={SystemPipeLineListsScreenStore}
                SystemListsScreenStore={SystemListsScreenStore}
                NominationScreenStore={NominationScreenStore}
                PLMAlarmDataStore={PLMAlarmDataStore}
                NGLSpotPriceAndTowerTargetsDataStore={NGLSpotPriceAndTowerTargetsDataStore}
            >
                <Routes />
            </Provider>
        );
    }
}

export default MainSolution;